import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WebFooter = ({ setShowHelp }) => {
    return (
        <footer
            style={{
                backgroundColor: "black",
                color: "#fff",
                padding: "16px",
                textAlign: "center",
                marginTop: "auto",
                width: "100%", // Ensures full width
                boxSizing: "border-box",
                position: "relative",
                borderTop: "2px solid #ccc",
            }}
        >
            <div
                style={{
                    maxWidth: "1200px",
                    margin: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        gap: "16px",
                        paddingBottom: "16px",
                    }}
                >
                    <div
                        style={{
                            width: "30%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                        }}
                    >
                        <h3 style={{ fontSize: "14px",marginTop: "24px" }}>
                            Movie information and posters from:
                        </h3>
                        <img
                            src="/tmdb-logo-long.svg"
                            alt="The Movie Database"
                            style={{
                                width: "60%",
                                marginTop: "8px",
                                alignSelf: "flex-start",
                            }}
                        />
                    </div>

                    <div
                        style={{
                            width: "60%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {/* Branding */}
                        <div style={{ marginBottom: "12px" }}>
                            <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>
                                CineSnake
                            </h2>
                            <p style={{ fontSize: "14px", color: "#aaa" }}>
                                The ultimate movie trivia challenge.
                            </p>
                        </div>

                        {/* Navigation Links */}
                        <nav
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "center",
                                gap: "12px",
                                fontSize: "14px",
                                marginBottom: "12px",
                            }}
                        >
                            <a
                                href="#"
                                onClick={() => setShowHelp(true)}
                                style={{
                                    color: "#bbb",
                                    textDecoration: "none",
                                    transition: "color 0.3s",
                                }}
                            >
                                Help
                            </a>
                            <a
                                href="/terms-of-service"
                                style={{
                                    color: "#bbb",
                                    textDecoration: "none",
                                    transition: "color 0.3s",
                                }}
                            >
                                Terms of Service
                            </a>
                            <a
                                href="/privacy-policy"
                                style={{
                                    color: "#bbb",
                                    textDecoration: "none",
                                    transition: "color 0.3s",
                                }}
                            >
                                Privacy Policy
                            </a>
                        </nav>

                        {/* Social Icons */}
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                marginTop: "12px",
                                justifyContent: "center",
                            }}
                        >
                            <a
                                href="https://twitter.com/cinesnake"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: "white",
                                    transition: "color 0.3s",
                                }}
                            >
                                <FontAwesomeIcon icon={["fab", "x-twitter"]} />
                            </a>
                            <a
                                href="mailto:cinesnakegame@gmail.com"
                                style={{
                                    color: "white",
                                    transition: "color 0.3s",
                                }}
                            >
                                <FontAwesomeIcon icon={["fas", "envelope"]} />
                            </a>
                        </div>

                        {/* Copyright */}
                        <p
                            style={{
                                fontSize: "12px",
                                color: "#777",
                                marginTop: "12px",
                            }}
                        >
                            © {new Date().getFullYear()} CineSnake. All rights
                            reserved.
                        </p>
                    </div>

                    <div style={{ width: "20%" }} />
                </div>
            </div>
        </footer>
    );
};

export default WebFooter;
